import React, { useContext, useState } from 'react'
import { RELATED_CONTENT } from '../../utils/apiUrls'
import useAxios from 'axios-hooks'
import InComponentLoader from '../../components/InComponentLoader'
import { isEmpty } from 'lodash'
import { getImage, getReleaseDate } from '../../utils/helper'
import CustomImage from '../../components/customImage/customImage'
import { AppContext } from '../../context/app'
import PlayIcon from '../../assets/play-circle-thick.svg'
import AudioIcon from '../../assets/audio-thumbnail-icon.svg'
import { useNavigate } from 'react-router'
import LiveIcon from '../../assets/live-icon-channel.png'
import { useTranslation } from 'react-i18next'
import ProgressBar from '../../components/progressBar/progressBar'
import { ContentContext } from '../../context/content'
import { TemplateContext } from '../../context/template'

const MultiPlayerPageSidebar = ({ contentId, childContent }) => {
  const [activeTab, setActiveTab] = useState(1)
  const { accountObj } = useContext(AppContext)
  const { getResumeTimestamp, isVideoPlaying } = useContext(ContentContext)
  const { contentDetailTemplateData } = useContext(TemplateContext)
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [{ data: relatedVideos, loading: relatedVideosLoading }] = useAxios({
    url: `${RELATED_CONTENT}${contentId}`,
    method: 'post',
    data: { filters: { video_types: ['MPVP'] } },
  })

  const handleRedirect = (content) => {
    if (content.video_type === 'PLAYLIST' || content.audio_type === 'PLAYLIST') {
      navigate(`/playlist/${content.content_id}`)
      return
    }
    if (content.video_type === 'MPVP' || content.audio_type === 'MPAP') {
      navigate(`/parent-content/${content.content_id}`)
    } else {
      if (content.video_type === 'MPVC' || content.audio_type === 'MPAC') {
        navigate(`/series-watch/${content.content_id}`)
        return
      }
      navigate(`/content-watch/${content?.content_id}`)
    }
  }

  const handlePlayEpisode = (content) => {
    navigate(`/series-watch/${content.content_id}`)
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!contentDetailTemplateData?.data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = contentDetailTemplateData?.data?.style_config[parentKey]?.data.filter(
      (info) => info.key === childKey,
    )

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <div className="w-full h-[470px] lg:h-full ">
      <InComponentLoader loading={relatedVideosLoading} />
      <div style={{}} className=" flex ">
        <div
          style={{
            color: activeTab === 1 ? '#09e9e9' : '#acacac',
            borderRadius: '10px 10px 0  0 ',
            marginLeft: '0.5%',
            background: activeTab === 1 ? '#000' : '#2c3747',
          }}
          className={`${
            activeTab === 1 && 'font-semibold'
          } cursor-pointer text-center items-center py-3 text-xs md:text-base flex-1 `}
          onClick={() => setActiveTab(1)}
        >
          {t('episodes')}
        </div>

        <div
          style={{
            color: activeTab === 2 ? '#09e9e9' : '#acacac',

            borderRadius: '10px 10px 0  0 ',
            background: activeTab === 2 ? '#000' : '#2c3747',
          }}
          className={`${
            activeTab === 2 && 'font-semibold'
          } cursor-pointer text-center items-center py-3 text-xs md:text-base flex-1 `}
          onClick={() => setActiveTab(2)}
        >
          {t('related_contents')}
        </div>
      </div>
      <div style={{ borderRadius: '0 0 10px 10px' }} className=" mt-1 h-full overflow-hidden">
        {activeTab === 1 && (
          <div
            // style={{ aspectRatio: '593/1209' }}
            style={{ borderRadius: '0 0 10px 10px' }}
            className="w-full bg-black px-1 lg:px-2 h-[89%] lg:h-auto lg:max-h-[900px] xl:max-h-[1100px] scrollbar-class lg:pb-3"
          >
            {childContent &&
              !isEmpty(childContent) &&
              [...childContent].map((content, index) => {
                return (
                  <div
                    key={index}
                    style={{ borderBottom: '1px solid #ffffff80' }}
                    className={` flex w-full py-3 px-3`}
                  >
                    <div
                      style={{ aspectRatio: '1.77' }}
                      className="relative flex justify-center items-center cursor-pointer h-[85px] lg:h-[90px] 2xl:h-[100px]"
                      onClick={() => handlePlayEpisode(content)}
                    >
                      <CustomImage
                        imageUrl={getImage(accountObj?.cf_domain_name, content?.thumbnail)}
                        imgClass="w-full h-full z-0 absolute rounded-lg"
                        loaderClass={'w-full h-full z-0 absolute rounded-lg'}
                        imgAlt={'play'}
                      />

                      <div
                        style={{
                          width: '17px',
                          height: '17px',
                          backgroundImage: 'linear-gradient(138deg, #000 14%, #5a5858 85%)',
                        }}
                        className="  absolute top-0 left-0 m-1 text-xs font-bold rounded text-white flex justify-center items-center"
                      >
                        <p>{index + 1}</p>
                      </div>

                      {getResumeTimestamp(content?.content_id) ? (
                        <div className=" w-full px-2.5 absolute bottom-0 mb-1">
                          <ProgressBar
                            bgColor={'#bbbbbb'}
                            height={'2px'}
                            barClass={''}
                            progressWidth={`${Number(
                              (getResumeTimestamp(content?.content_id) / content?.duration_in_s) *
                                100,
                            )}%`}
                            progressColor={getStyleValue(
                              'play_button',
                              'background_color1',
                              '#bbfa33',
                            )}
                          />
                        </div>
                      ) : null}

                      {content?.asset_type === 'VIDEO' ? (
                        <img
                          style={{ width: '40px', height: '40px' }}
                          className="absolute z-10"
                          src={PlayIcon}
                          alt="PlayIcon"
                        />
                      ) : (
                        <img
                          style={{ width: '40px', height: '40px' }}
                          className="absolute z-10"
                          src={AudioIcon}
                          alt="AudioIcon"
                        />
                      )}
                    </div>
                    <div style={{ marginLeft: '5%', color: '#fff' }}>
                      <p className="font-semibold 2xl:text-xl xl:text-lg lg:text-base line-clamp-2">
                        {content.title}
                      </p>
                      <p className="text-sm mt-1 line-clamp-1">{content.duration}</p>
                      {isVideoPlaying && contentId === content?.content_id && (
                        <div
                          style={{ background: '#ff0000', padding: '3.5px 7px' }}
                          className="w-fit text-xs rounded mt-2 "
                        >
                          Playing now
                        </div>
                      )}
                    </div>
                  </div>
                )
              })}
          </div>
        )}
        {activeTab === 2 && (
          <div
            // style={{ aspectRatio: '593/1209' }}
            style={{ borderRadius: '0 0 10px 10px' }}
            className="w-full bg-black px-1 lg:px-2 h-[89%] lg:aspect-[593/1209] lg:h-[96.25%] scrollbar-class"
          >
            {relatedVideos &&
              !isEmpty(relatedVideos?.data) &&
              relatedVideos?.data.map((content, index) => {
                return (
                  <div
                    key={index}
                    style={{ borderBottom: '1px solid #ffffff80' }}
                    className={` flex w-full py-3 px-3`}
                  >
                    <div
                      style={{ aspectRatio: '1.77' }}
                      className="relative flex justify-center items-center cursor-pointer h-[85px] lg:h-[90px] 2xl:h-[100px]"
                      onClick={() => handleRedirect(content)}
                    >
                      <CustomImage
                        imageUrl={getImage(accountObj?.cf_domain_name, content?.thumbnail)}
                        imgClass="w-full h-full z-0 absolute rounded-lg"
                        loaderClass={'w-full h-full z-0 absolute rounded-lg'}
                        imgAlt={'play'}
                      />
                      {content?.video_type === 'LIVE' ? (
                        <img
                          src={LiveIcon}
                          className="absolute h-4 m-2 z-10 top-0 right-0"
                          alt="LiveIcon"
                        />
                      ) : null}
                      {content?.asset_type === 'VIDEO' ? (
                        <img
                          style={{ width: '40px', height: '40px' }}
                          className="absolute z-10"
                          src={PlayIcon}
                          alt="PlayIcon"
                        />
                      ) : (
                        <img
                          style={{ width: '40px', height: '40px' }}
                          className="absolute z-10"
                          src={AudioIcon}
                          alt="AudioIcon"
                        />
                      )}
                    </div>
                    <div style={{ marginLeft: '5%', color: '#fff' }}>
                      <p className="font-semibold 2xl:text-xl xl:text-lg lg:text-base line-clamp-2">
                        {content.title}
                      </p>
                      {!isEmpty(content.release_time) && (
                        <p className="text-sm mt-1">
                          {t('release_date')} : {getReleaseDate(content.release_time)}
                        </p>
                      )}
                      <p className="text-sm mt-1 line-clamp-1">{content.description}</p>
                    </div>
                  </div>
                )
              })}
          </div>
        )}
      </div>
    </div>
  )
}

export default MultiPlayerPageSidebar
